import { useTextTranslation } from "../../utils/useTextTranslation";
import { catalogLabel } from "../../utils/catalogLabel";
import React, { useRef } from "react";
import { NavLink, useParams } from "react-router-dom";

const CategoryItem = ({ item, selectedCategoryId }) => {
  const translateText = useTextTranslation();
  let { menuId } = useParams();
  const elRef = useRef(null);

  return (
    <div>
      <NavLink
        to={{
          pathname: `/dashboard/home/${menuId}/${item?.id}`
        }}
        style={{ textDecoration: "none" }}
      >
        <div
          ref={elRef}
          key={item?.id}
          className={`category-item ${
            selectedCategoryId == item?.id ? "selected" : ""
          }`}
        >
          {translateText(catalogLabel(item?.name))}
        </div>
      </NavLink>
    </div>
  );
};

export default CategoryItem;
